let themeObserver = null;

export const isBpi = () => {
  if (typeof window === 'undefined') return false;
  const pathname = window.location.pathname;
  if (pathname.startsWith('/bpi')) {
    localStorage.setItem('isBpi', 'true');
    return true;
  }
  if (pathname === '/signin' || pathname === '/signup') {
    localStorage.removeItem('isBpi');
    return false;
  }
  return localStorage.getItem('isBpi') === 'true';
};

export const getLogo = (logoType) => {
  if (isBpi()) {
    return require("assets/bpi_wealth.png");
  }
  switch (logoType) {
    case 'logo':
      return require("assets/images/logo.png");
    case 'logo-white':
      return require("assets/images/logo-white.png");
    case 'logo-big':
      return require("assets/images/logo-big.png");
    case 'w-logo':
      return require("assets/images/w-logo.png");
    default:
      return require("assets/images/logo.png");
  }
};

export const getPath = (path) => {
  if (isBpi()) {
    if (path.startsWith('/bpi')) {
      return path;
    }
    return `/bpi${path.startsWith('/') ? '' : '/'}${path}`;
  }
  return path;
};

export const applyTheme = () => {
  if (typeof window === 'undefined') return;

  const runOverride = () => {
    const active = isBpi();
    if (!active) {
      const existing = document.getElementById('bpi-theme-overrides');
      if (existing) {
        existing.remove();
      }
      return;
    }

    let cssContent = '';
    const styleElements = document.getElementsByTagName('style');
    for (let i = 0; i < styleElements.length; i++) {
      const styleEl = styleElements[i];
      if (styleEl.id === 'bpi-theme-overrides') continue;
      cssContent += styleEl.innerHTML;
    }

    const linkElements = document.getElementsByTagName('link');
    const promises = [];
    for (let i = 0; i < linkElements.length; i++) {
      const link = linkElements[i];
      if (link.rel === 'stylesheet' && link.href && link.href.indexOf(window.location.origin) === 0) {
        promises.push(
          fetch(link.href)
            .then(res => res.text())
            .then(text => {
              cssContent += text;
            })
            .catch(err => console.error('Failed to fetch stylesheet:', err))
        );
      }
    }

    const applyReplacements = () => {
      let modifiedCss = cssContent
        .replace(/#F87060/g, '#DC2626')
        .replace(/#f87060/g, '#DC2626');

      // Add rules to override inline style declarations (hex and rgb)
      modifiedCss += `
        [style*="color: #f87060"] { color: #DC2626 !important; }
        [style*="color: #F87060"] { color: #DC2626 !important; }
        [style*="color:#f87060"] { color: #DC2626 !important; }
        [style*="color:#F87060"] { color: #DC2626 !important; }

        [style*="background-color: #f87060"] { background-color: #DC2626 !important; }
        [style*="background-color: #F87060"] { background-color: #DC2626 !important; }
        [style*="background-color:#f87060"] { background-color: #DC2626 !important; }
        [style*="background-color:#F87060"] { background-color: #DC2626 !important; }

        [style*="background: #f87060"] { background: #DC2626 !important; }
        [style*="background: #F87060"] { background: #DC2626 !important; }
        [style*="background:#f87060"] { background: #DC2626 !important; }
        [style*="background:#F87060"] { background: #DC2626 !important; }

        [style*="border-color: #f87060"] { border-color: #DC2626 !important; }
        [style*="border-color: #F87060"] { border-color: #DC2626 !important; }
        [style*="border-color:#f87060"] { border-color: #DC2626 !important; }
        [style*="border-color:#F87060"] { border-color: #DC2626 !important; }

        /* rgb representation (248, 112, 96) */
        [style*="color: rgb(248, 112, 96)"], [style*="color: rgb(248,112,96)"], [style*="color:rgb(248, 112, 96)"], [style*="color:rgb(248,112,96)"] { color: #DC2626 !important; }
        [style*="background-color: rgb(248, 112, 96)"], [style*="background-color: rgb(248,112,96)"], [style*="background-color:rgb(248, 112, 96)"], [style*="background-color:rgb(248,112,96)"] { background-color: #DC2626 !important; }
        [style*="background: rgb(248, 112, 96)"], [style*="background: rgb(248,112,96)"], [style*="background:rgb(248, 112, 96)"], [style*="background:rgb(248,112,96)"] { background: #DC2626 !important; }
        [style*="border-color: rgb(248, 112, 96)"], [style*="border-color: rgb(248,112,96)"], [style*="border-color:rgb(248, 112, 96)"], [style*="border-color:rgb(248,112,96)"] { border-color: #DC2626 !important; }
      `;

      let styleOverride = document.getElementById('bpi-theme-overrides');
      if (!styleOverride) {
        styleOverride = document.createElement('style');
        styleOverride.id = 'bpi-theme-overrides';
        document.head.appendChild(styleOverride);
      }
      if (styleOverride.innerHTML !== modifiedCss) {
        styleOverride.innerHTML = modifiedCss;
      }
    };

    if (promises.length > 0) {
      Promise.all(promises).then(applyReplacements);
    } else {
      applyReplacements();
    }
  };

  runOverride();

  if (!themeObserver && typeof MutationObserver !== 'undefined') {
    themeObserver = new MutationObserver((mutations) => {
      let shouldUpdate = false;
      for (let mutation of mutations) {
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if ((node.tagName === 'STYLE' || node.tagName === 'LINK') && node.id !== 'bpi-theme-overrides') {
            shouldUpdate = true;
            break;
          }
        }
        if (shouldUpdate) break;
      }
      if (shouldUpdate) {
        runOverride();
      }
    });
    themeObserver.observe(document.head, { childList: true });
  }
};
